import { render, staticRenderFns } from "./raised_buttons.vue?vue&type=template&id=6f335d80"
import script from "./raised_buttons.vue?vue&type=script&lang=js"
export * from "./raised_buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports